import React, { Component } from 'react';
import PageWrapper from '../../components/shared/PageWrapper';
import LeadTracker from '../../components/leadtracker/LeadTracker';
import { connect } from 'react-redux';
import { actions } from "../../config/reduxIndex";
import moment from 'moment-timezone';

class LeadTrackerContainer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			mode: 'search',
			today: null,
			searchText: '',
		}

	}

	componentWillMount() {
		//const { setDefault } = this.props;
		const { getLeadsData } = this.props;

		getLeadsData();

		this.setState({
			isLoading: true,
			today: moment().format('YYYY-MM-DD'),
		})
	}

	componentDidMount() {
		this.setState({
			isLoading: false,
		})
	}

	render() {
		const { isLoading } = this.state;
		const { leadData } = this.props;
		let leads = leadData.leads;

		return (
			<div className="page">
				{!isLoading ? this.show() : this.loading()}
			</div>
		);
	}


	show = () => {
		const { match, leadData } = this.props;
		const { leads } = leadData;
		const { mode } = this.state;

		let sections = [
			{ title: 'Overdue', data: this.filterBySearch(leads.filter(this.isOverDue)) },
			{ title: 'Due', data: this.filterBySearch(leads.filter(this.isDue)) },
			{ title: 'Inactive', data: this.filterBySearch(leads.filter(this.isInactive)) }
		];

		return (
			<PageWrapper
				match={match}
			>
				<LeadTracker
					mode={mode}
					sections={sections}
					gotoMode={this.gotoMode}
					searchOnChange={this.searchOnChange}
					searchText={this.state.searchText}
					gotoEditLead={this.gotoEditLead}
					gotoNewLead={this.gotoNewLead}
				/>

			</PageWrapper>
		);
	}

	loading = () => {
		const { match } = this.props;
		return (
			<PageWrapper
				match={match}
			>
				<div className="content">
					<div className="content_center">
							Loading
					</div>
				</div>

			</PageWrapper>
		);
	}

	isOverDue = (e) => {
		// overdue: status of not complete and duedate prior to today
		return (e.complete === 'N'
			&& moment(e.dueDate).isBefore(this.state.today)
		)
	}

	isDue = (e) => {
		// due: status not complete and duedate later than today
		return (e.dateDue === undefined || // TODO come up with a better way
			(e.complete === 'N' && moment(e.dueDate).isAfter(this.state.today))
		)
	}

	isInactive = (e) => {
		// inactive: has status of complete
		return (e.complete === 'Y')
	}

	filterBySearch = (list) => {
		let filtered = list.filter(this.doesMatch)
		return filtered
	}

	doesMatch = (e) => {
		const { searchText } = this.state;
		let result = false;

		if (e.companyName !== null && e.companyName.toLowerCase().includes(searchText))
			result = true;
		else if (e.contactFirstName !== null && e.contactFirstName.toLowerCase().includes(searchText))
			result = true;
		else if (e.contactLastName !== null && e.contactLastName.toLowerCase().includes(searchText))
			result = true;

		return result;
	}

	searchOnChange = async (e) => {
		this.setState({
			searchText: e.toLowerCase()
		})
	}

	gotoMode = (e) => {
		this.setState({
			mode: e
		})
	}

	gotoNewLead = () => {
		this.gotoMode('new');
	}

	gotoEditLead = (props) => {
		let obj = { editLead: props }
		this.props.setAttributeByObj(obj);
		this.gotoMode('edit');
	}

}

const mapStateToProps = state => {
	return {
		leadData: state.leadData
	}
};

const mapDispatchToProps = dispatch => {
	return {
		setDefault: () => {
			dispatch(actions.leadData.setDefault())
		},
		setAttributeByObj: (props) => {
			dispatch(actions.leadData.setAttributeByObj(props))
		},
		getLeadsData: () => {
			dispatch(actions.leadData.getLeadsData());
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadTrackerContainer);


// WEBPACK FOOTER //
// ./src/containers/leadtracker/LeadTrackerContainer.js